/* istanbul ignore file */

import { MapElementColor, UserSelectablePresetColors } from '../enums';

export const HEX_BY_CONTEXT_LAYER_COLOR_CONSTANTS: Record<MapElementColor, UserSelectablePresetColors> = {
    [MapElementColor.Red]: UserSelectablePresetColors.SolidRed,
    [MapElementColor.Orange]: UserSelectablePresetColors.SolidOrange,
    [MapElementColor.Yellow]: UserSelectablePresetColors.SolidYellow,
    [MapElementColor.Green]: UserSelectablePresetColors.SolidGreen,
    [MapElementColor.Aqua]: UserSelectablePresetColors.SolidAqua,
    [MapElementColor.Blue]: UserSelectablePresetColors.SolidBlue,
    [MapElementColor.Purple]: UserSelectablePresetColors.SolidPurple,
    [MapElementColor.Gray]: UserSelectablePresetColors.SolidGray,
    [MapElementColor.Black]: UserSelectablePresetColors.Black,
    [MapElementColor.White]: UserSelectablePresetColors.White,
    [MapElementColor.NoColor]: UserSelectablePresetColors.Transparent,
};
